import { Controller } from '@hotwired/stimulus'
import { createApp, h, ref, watch } from 'vue'
import ImagePicker from '../components/AppImagePicker.vue'

class ImagePickerController extends Controller<HTMLInputElement> {
  static values = {
    imageUrlTemplate: String,
    defaultLicenseId: Number,
  }

  declare readonly imageUrlTemplateValue: string
  declare readonly defaultLicenseIdValue: number

  _container?: HTMLDivElement
  _app?: ReturnType<typeof createApp>

  async connect() {
    const container = document.createElement('div')
    const imageValue = this.element.getAttribute('value')?.trim?.()
    const imageId = ref<number | undefined>(imageValue ? parseInt(imageValue) : undefined)
    this.element.insertAdjacentElement('afterend', container)
    this._container = container
    watch(imageId, (newId) => {
      if (typeof newId === 'number') {
        this.element.value = newId.toString()
      } else {
        this.element.value = ''
      }
    })
    const component = h(
      // @ts-ignore
      ImagePicker,
      {
        onUpdate(newImageId: number | undefined) {
          imageId.value = newImageId
        },
      },
    )
    this._app = createApp(component, {
      imageId,
      imageURLTemplate: this.imageUrlTemplateValue,
      defaultLicenseId: this.defaultLicenseIdValue,
    })
    this._app.mount(container)
  }

  disconnect() {
    if (this._app) {
      this._app.unmount()
    }
    if (this._container) {
      this._container.remove()
    }
  }
}

export default ImagePickerController
